import {
  $1
} from 'utilities/selector'

import CarouselPlugin from './base-plugin'

// Class
export default function DNLinksPlugin(config) {
  if (!(this instanceof DNLinksPlugin))
    return new DNLinksPlugin(config);

  this.options = Object.assign({}, DNLinksPlugin.defaults, config);

}

// Extends
DNLinksPlugin.prototype = Object.create(CarouselPlugin.prototype);
DNLinksPlugin.prototype.constructor = DNLinksPlugin;

// Static
DNLinksPlugin.displayName = "DNLinksPlugin";
DNLinksPlugin.defaults = {
  elements: [{
    key: 'links',
    multiple: true,
    selector: '[data-link]',
  }]
};

// Methods
DNLinksPlugin.prototype.init = function () {
  if (this.carousel.elements.links && this.carousel.elements.links.length) {
    [...this.carousel.elements.links].forEach(this.setupLinks, this)
  }
};

DNLinksPlugin.prototype.setupLinks = function (el, i) {

  let item = el.parentNode;
  let url = el.innerHTML.trim();

  if (url !== '' && url !== 'Link goes here') {
    item.style.cursor = "pointer";
  }

  item.addEventListener('click', () => {
    if ( url !== '' && url != 'Link goes here') {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank')
      } else {
        window.location = url;
      }
    }
  });
};


// WEBPACK FOOTER //
// ./scripts/components/carousels/plugins/dnlinks-plugin.js